/* ==========================================================================
   SearcherFerryHotelRxjs > Client >constants
   ========================================================================== */

module.exports = {
    ENDPOINTS: {
        route: '/ferriesShowcase/Shima/GetRouteData',
        ports: '/ferriesShowcase/Shima/GetPorts'
    },
    CALENDAR: {
        mode: 'range',
        DATE_FORMAT: 'yyyy-LL-dd',
        stringDateFormat: 'dd LLLL yyyy',
        dateFormat: 'Y-m-d',
        ariaDateFormat: 'Y-m-d',
        static: true,
        inline: true,
        showMonths: 2,
        sameDay: false,
        releaseDays: 2
    },
    VEHICLE: {
        vehicleHeight: 160,
        vehicleLength: 350,
        trailerHeight: 10,
        trailerLength: 10,
        trailer: false
    },
    ACCOMMODATION: {
        maxRooms: 4,
        maxPeople: 9,
        adults: {
            min: 1,
            max: 6,
            value: 2
        },
        children: {
            min: 0,
            max: 4,
            value: 0,
            maxAge: 11,
            defaultAge: 7
        },
        rooms: [
            {
                adults: 2,
                children: 0
            }
        ]
    },
    LOADING: {
        src: '/comun/images/lineas/ferries_800x600.jpg'
    }
};
